<template>
  <div>
    <b-carousel :autoplay="false" with-carousel-list :indicator="false">
      <b-carousel-item
        v-for="(image, i) in images"
        :key="i"
        @click="openModal(i)"
      >
        <figure class="carousel-image">
          <img v-lazy="getImgUrl(image.path)" :alt="image.name" />
          <figcaption v-if="image.caption != null">
            {{ image.caption }}
          </figcaption>
        </figure>
      </b-carousel-item>
      <template #list="props">
        <b-carousel-list
          v-model="props.active"
          :data="indicatorImages"
          v-bind="al"
          @switch="props.switch($event, false)"
          as-indicator
        />
      </template>
    </b-carousel>
    <b-modal v-model="imageClicked">
      <img
        v-lazy="getImgUrl(images[imageClickedIndex].path)"
        :alt="images[imageClickedIndex].name"
      />
      <p v-if="images[imageClickedIndex].caption != null" class="center-text">
        {{ images[imageClickedIndex].caption }}
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    // Takes the relevant info about images, with a path relative to the site number
    // Along with captions if relevant: [{name: "img", path: "/path/img.png", caption?: "img"},]
    images: {
      type: Array
    }
  },
  data() {
    return {
      al: {
        hasGrayscale: true,
        itemsToShow: 4,
        breakpoints: {
          768: {
            hasGrayscale: false,
            itemsToShow: 4
          },
          960: {
            hasGrayscale: true,
            itemsToShow: 6
          }
        }
      },
      imageClicked: false,
      imageClickedIndex: 0
    };
  },
  computed: {
    selected() {
      return this.$store.state.selected;
    },
    indicatorImages() {
      let imgArray = [];
      for (let i = 0; i < this.images.length; i++) {
        imgArray[i] = {
          title: this.images[i].title,
          image: this.getImgUrl(this.images[i].path)
        };
      }
      return imgArray;
    }
  },
  methods: {
    getImgUrl(path) {
      return require(`@/assets/sites/${this.selected}/${path}`);
    },
    switchGallery(value) {
      this.gallery = value;
      if (value) {
        return document.documentElement.classList.add("is-clipped");
      } else {
        return document.documentElement.classList.remove("is-clipped");
      }
    },
    openModal(index) {
      this.imageClicked = true;
      this.imageClickedIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel-image {
  display: flex;
  flex-flow: column;
  width: 100%;

  img {
    width: auto;
    height: 30vh;
    object-fit: contain;
    border: none;
  }

  figcaption {
    background-color: #222;
    color: #fff;
    font-size: smaller;
    font-style: italic;
    padding: 0.25rem;
    text-align: center;
    width: 100%;
  }
}
</style>

<style lang="scss">
.carousel-slide {
  figure {
    img {
      padding: 3px;
      border: none;
      height: 10vh;
      object-fit: scale-down;
      opacity: 0.75;
      filter: brightness(75%);
    }
  }
}

.carousel-slide.is-active {
  figure {
    img {
      opacity: 1;
      filter: brightness(100%);
      border-bottom: #c0c0c0;
      border-style: solid;
      border-top: none;
      border-left: none;
      border-right: none;
      background-color: #731233;
    }
  }
}

.modal-close {
  top: 4rem !important;
}

img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.center-text {
  text-align: center;
  margin-top: 1%;
}
</style>
